"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _Theme = require("../constants/Theme");
var ThemeContext = (0, _react.createContext)({
  theme: _Theme.DARK_THEME,
  setTheme: function setTheme() {}
});
var _default = exports["default"] = ThemeContext;